import { Stack, useToast, Button } from '@chakra-ui/react';
import React, { useEffect, useState, useCallback } from 'react';
import GoogleIcon from '../icons/GoogleIcon';
import { useGoogleLogin } from '@react-oauth/google';
import { useMutation } from '@apollo/client';
import { useError } from '../../../error-provider/ErrorProvider';
import FacebookLogin from '@greatsumini/react-facebook-login';
import FacebookIcon from '../icons/FacebookIcon';
import LinkedInIcon from '../icons/LinkedInIcon';
import { SocialAuth } from '../../../graphql/mutations/SocailAuth';
import { FACEBOOK_ID, linkedinOAuthURL } from '../../../utils/constants';
import { saveToken } from '../../../utils/auth';
import { PATHS } from '../../../router/routes';
import Loader from '../loader/Loader';

const SocialButtons = ({ type, iconRow }) => {
    const { showError } = useError();
    const toast = useToast();

    const [googleResponse, setGoogleRespone] = useState(null);
    const [facebookResponse, setFacebookResponse] = useState(null);
    const [isLoginFalied, setLoginFailed] = useState(false);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get('code');

    const [signSocial] = useMutation(SocialAuth, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const googleSignIn = useGoogleLogin({
        onSuccess: (tokenResponse) => setGoogleRespone(tokenResponse),
        onError: () => console.log('login failed'),
    });

    const onSignSocial = useCallback(async (token, provider) => {
        await signSocial({
            variables: {
                provider: provider,
                accessToken: token,
            },
            onCompleted(data) {
                if (data?.socialAuth?.__typename === 'SuccessType') {
                    localStorage.setItem('remindMe', true);
                    saveToken(data?.socialAuth?.message);

                    window.location.href = PATHS.MY_AGENT;
                } else {
                    setLoginFailed(true);
                    toast({
                        title: data?.socialAuth?.message,
                        status: 'error',
                        isClosable: true,
                    });
                }
            },
        });
    }, [signSocial, toast]);

    const handleLinkedInCallback = useCallback(() => {
        if (code) onSignSocial(code, 'linkedin_oauth2');
    }, [code, onSignSocial]);

    useEffect(() => {
        handleLinkedInCallback();
    }, [handleLinkedInCallback]);

    const socialButtons = [
        { text: 'Sign In With Google', leftIcon: <GoogleIcon />, onClick: () => googleSignIn(), provider: 'google' },
        {
            text: 'Sign In With Facebook',
            leftIcon: <FacebookIcon />,
            provider: 'facebook',
        },
        {
            text: 'Sign In With LinkedIn',
            leftIcon: <LinkedInIcon />,
            onClick: () => (window.location.href = linkedinOAuthURL),
            provider: 'linkedin',
        },
    ];

    useEffect(() => {
        if (googleResponse) {
            onSignSocial(googleResponse?.access_token, 'google');
        }

        if (facebookResponse) {
            onSignSocial(facebookResponse?.accessToken, 'facebook');
        }
    }, [googleResponse, facebookResponse, onSignSocial]);

    if (code && !isLoginFalied) {
        return <Loader />;
    }

    if (iconRow || type === 'iconRow') {
        return (
            <div className='grid grid-cols-3 gap-3'>
                {socialButtons.map((item) => {
                    if (item.provider === 'facebook') {
                        return (
                            <FacebookLogin
                                key={item.provider}
                                scope='public_profile, email'
                                appId={FACEBOOK_ID}
                                onSuccess={(response) => {
                                    setFacebookResponse(response);
                                }}
                                onFail={(error) => {
                                    console.log('Login Failed!', error);
                                }}
                                onProfileSuccess={(response) => {
                                    console.log('Get Profile Success!', response);
                                }}
                                render={({ onClick }) => (
                                    <button
                                        className='flex items-center justify-center h-11 rounded-lg border border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all'
                                        onClick={onClick}
                                    >
                                        {item.leftIcon}
                                        <span className='sr-only'>{item.provider}</span>
                                    </button>
                                )}
                            />
                        );
                    }

                    return (
                        <button
                            key={item.provider}
                            className='flex items-center justify-center h-11 rounded-lg border border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all'
                            onClick={item.onClick}
                        >
                            {item.leftIcon}
                            <span className='sr-only'>{item.provider}</span>
                        </button>
                    );
                })}
            </div>
        );
    }

    if (type === 'row') {
        return (
            <div className='mt-6 grid grid-cols-3 gap-3'>
                {socialButtons.map((item) => {
                    if (item.provider === 'facebook') {
                        return (
                            <FacebookLogin
                                scope='public_profile, email'
                                appId={FACEBOOK_ID}
                                onSuccess={(response) => {
                                    setFacebookResponse(response);
                                }}
                                onFail={(error) => {
                                    console.log('Login Failed!', error);
                                }}
                                onProfileSuccess={(response) => {
                                    console.log('Get Profile Success!', response);
                                }}
                                render={({ onClick }) => (
                                    <Button variant='outline' className='w-full' onClick={onClick}>
                                        {item.leftIcon}
                                        <span className='sr-only'>{item.provider}</span>
                                    </Button>
                                )}
                            />
                        );
                    }

                    return (
                        <Button variant='outline' className='w-full' onClick={item.onClick}>
                            {item.leftIcon}
                            <span className='sr-only'>{item.provider}</span>
                        </Button>
                    );
                })}
            </div>
        );
    }

    return (
        <Stack spacing='2'>
            {socialButtons.map((item) => {
                const zaraButton = (onClick = item.onClick) => (
                    <Button
                        leftIcon={item.leftIcon}
                        variant='outline'
                        className='w-full font-open-sans'
                        fontSize='sm'
                        onClick={onClick}
                        key={item.provider}
                    >
                        {item.text}
                    </Button>
                );

                if (item.provider === 'facebook') {
                    return (
                        <FacebookLogin
                            scope='public_profile, email'
                            appId={FACEBOOK_ID}
                            onSuccess={(response) => {
                                setFacebookResponse(response);
                            }}
                            onFail={(error) => {
                                console.log('Login Failed!', error);
                            }}
                            onProfileSuccess={(response) => {
                                console.log('Get Profile Success!', response);
                            }}
                            render={({ onClick }) => zaraButton(onClick)}
                        />
                    );
                } else {
                    return zaraButton();
                }
            })}
        </Stack>
    );
};

export default SocialButtons;
